import { Button, Grid } from '@mui/material'
import React, { useEffect } from 'react'
import { AlertBase } from '../../components/_WMS/Alert/AlertBase'
import { DateTime } from 'luxon'
import { useApi } from '../../hooks/useApi'
import { WorkOrderOutbound } from '../../interfaces/WorkOrderOutbound'
import { ApiResponse } from '../../typings/ApiResponse'
import { Status } from '../../hooks/useFetchState'
import { Filter } from '../../components/_WMS/FilterComponent'
import { WorkOrderState } from '../../interfaces'
import { getOrderRecallList } from './api'
import { Size } from '../../hooks/useModal'
import { workOrderForTodayStates, workOrderOverdueStates } from '../../utils/stateHelpers'


interface WorkOrderRecallButtonBarProps {
  handleSearch: (filters: Filter[], page?: number, pageSize?: number) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  workOrderStates: WorkOrderState[] | undefined
  onClickCreateWorkOrderRecall: (psize?: Size) => void
}

const overdueFilters = (workOrderStates: WorkOrderState[] | undefined) => {
  const elements = getWorkOrderStatesFilter(
    workOrderOverdueStates,
    workOrderStates
  )

  return [
    {
      key: 'initialPromiseDate',
      value: DateTime.utc(1970, 1, 1).toFormat('yyyy-MM-dd'),
      label: 'Fecha Compromiso Desde',
      displayValue: DateTime.utc(1970, 1, 1).toFormat('yyyy-MM-dd')
    },
    {
      key: 'finalPromiseDate',
      value: DateTime.local().toFormat('yyyy-MM-dd'),
      label: 'Fecha Compromiso Hasta',
      displayValue: DateTime.local().toFormat('yyyy-MM-dd')
    },
    ...elements
  ]
}

const forTodayFilters = (workOrderStates: WorkOrderState[] | undefined) => {
  const todayStart = DateTime.local().startOf('day').toFormat('yyyy-MM-dd')
  const todayEnd = DateTime.local().endOf('day').toFormat('yyyy-MM-dd')

  const elements = getWorkOrderStatesFilter(
    workOrderForTodayStates,
    workOrderStates
  )

  return [
    {
      key: 'initialPromiseDate',
      value: todayStart,
      label: 'Fecha Compromiso Desde',
      displayValue: todayStart
    },
    {
      key: 'finalPromiseDate',
      value: todayEnd,
      label: 'Fecha Compromiso Hasta',
      displayValue: todayStart
    },
    ...elements
  ]
}

const getWorkOrderStatesFilter = (
    validStates: number[],
    workOrderStates: WorkOrderState[] | undefined
  ) => {
    return validStates.map((workOrderStateId) => ({
      key: 'workOrderStateId',
      value: workOrderStateId.toString(),
      label: 'Estado',
      displayValue:
        workOrderStates !== undefined && workOrderStates.length > 0
          ? (workOrderStates || []).filter(
              (el) => el.workOrderStateId === workOrderStateId
            )[0].state || ''
          : ''
    }))
  }

export const WorkOrderRecallButtonBar: React.FC<WorkOrderRecallButtonBarProps> =
  ({
    setSelectedFilters,
    workOrderStates,
    onClickCreateWorkOrderRecall: onClickCreateWorkOrderRecall
  }) => {
    const { state: StateTodayAlert, callApi: StateTodayAlertCallApi } =
      useApi<ApiResponse<WorkOrderOutbound>>()

    const { state: StateOverdueAlert, callApi: StateOverdueAlertCallApi } =
      useApi<ApiResponse<WorkOrderOutbound>>()

    const requestOverdueWorkOrder = (filters: Filter[]) => {
      StateOverdueAlertCallApi(getOrderRecallList(filters))
    }
    const requestTodayWorkOrder = (filters: Filter[]) => {
      StateTodayAlertCallApi(getOrderRecallList(filters))
    }

    useEffect(() => {
        requestOverdueWorkOrder(overdueFilters(workOrderStates))
        requestTodayWorkOrder(forTodayFilters(workOrderStates))
      }, [])

    return (
      <Grid container justifyContent='center' spacing={2}>
        <Grid container item xs={12} md={4} spacing={3} >
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <AlertBase
              status='error'
              title={'Atrasadas'}
              count={StateOverdueAlert.data?.totalItems || 0}
              countDescription='OTs'
              loading={StateOverdueAlert.status === Status.Loading}
              onClick={() =>
                setSelectedFilters(overdueFilters(workOrderStates))
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <AlertBase
              status='warning'
              title={'Para hoy'}
              count={StateTodayAlert.data?.totalItems || 0}
              countDescription='OTs'
              loading={StateTodayAlert.status === Status.Loading}
              onClick={() =>
                setSelectedFilters(forTodayFilters(workOrderStates))
              }
            />
          </Grid>
        </Grid>

        <Grid container item xs={12} md={8} spacing={3} justifyContent='flex-end'>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={3}
            justifyContent='flex-end'
            alignContent='flex-end'
            alignItems='flex-end'
          ></Grid>
                    <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={3}
            justifyContent='flex-end'
            alignContent='flex-end'
            alignItems='flex-end'
          >
             <Button
              fullWidth
              variant='contained'
              color='primary'
              size='small'
              onClick={() => onClickCreateWorkOrderRecall('md')}
            >
              Crear Orden
            </Button>
          </Grid>
        </Grid>
      </Grid>
    )
  }
